import * as angular from 'angular';
import * as moment from 'moment';

import { ICalculatedStateParams } from '../calculated/components.index';
import { INavigationHistory, INavigationHistoryService } from '../../services';

export class NavigationHistoryStateController {
    static $inject = ['$state', '$stateParams', 'navigationHistoryService'];

    constructor(
        private $state: angular.ui.IStateService,
        private $stateParams: ICalculatedStateParams,
        private navigationHistoryService: INavigationHistoryService) {
    }

    $onInit() {
        const index = this.$stateParams['index'];
        const histories = this.navigationHistoryService.getNavigationHistories();

        const histo: INavigationHistory = histories[index]
            ? histories[index]
            : { page: 'home', name: 'Home', icon: 'fa-home', params: {}, interval: { begin: moment(), end: moment() } };


        // init params in case
        if (!histo.params) {
            histo.params = {};
        } else {
            histo.params = angular.copy(histo.params);
        }

        // force groupGuid parameter if present
        if (histo.groupGuid) {
            histo.params.groupGuid = histo.groupGuid;
        }

        // force date paramater if present
        if (histo.interval.begin) {
            histo.params.beginDate = histo.interval.begin.toISOString();
        }
        if (histo.interval.end) {
            histo.params.endDate = histo.interval.end.toISOString();
        }

        this.$state.go(histo.page, histo.params, { location: true });
    }
}